import React, { useState } from "react";
import { signOut } from "../../redux/signIn";
import styles from "./styles/Settings.module.css";
import useTranslation from "next-translate/useTranslation";
import { userStore } from "../../redux/user";
import { api } from "../../services/api";
import { Button } from "@/components/ui/button";

export default function CloseAccount() {
  const [show, setShow] = useState(false);
  const { t } = useTranslation("common");
  const { t: settingsT } = useTranslation("auth");

  function closeAccount() {
    //TODO: also close membership
    const userId = userStore.getState().id;
    api
      .delete("/users/" + userId)
      .then(() => {
        signOut();
      })
      .catch(() => {
        console.log("error in function closeAccount");
      });
  }

  function renderAreYouSure() {
    return (
      <div className={styles.areYouSure}>
        {t("Are you sure?")}
        <div className="flex items-center mt-5 space-x-2">
          <button
            className="btn btn-base btn-outline"
            onClick={() => {
              closeAccount();
            }}
          >
            {t("Yes")}
          </button>
          <button
            className="btn btn-base btn-blue"
            onClick={() => setShow(false)}
          >
            {t("No")}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.body}>
      <div className={styles.title}>{settingsT("Close account")}</div>
      <div className={styles.form}>
        <Button
          size="wide"
          variant="destructive"
          className="btn btn-base btn-red"
          onClick={() => setShow(true)}
        >
          {settingsT("Close account")}
        </Button>
        {show && renderAreYouSure()}
      </div>
    </div>
  );
}
